import MaterialsApiService from "./api/MaterialsApiService";

export const createMaterial = async (payload, userToken) => {
  const data = {
    name: payload.name,
    color: payload.color,
    discipline_id: payload.disciplineId
  }

  if (payload.image) {
    data.image = payload.image
  }

  try {
    const response = await MaterialsApiService.post('/materials', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao adicionar material', error);

    throw error;
  }
};

export const findMaterial = async (materialId, userToken) => {
  try {
    const response = await MaterialsApiService.get(`/materials/${materialId}`, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao consultar material', error);

    throw error;
  }
};

export const updateMaterial = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/materials/${payload.materialId}/update`, payload, {
      headers: {
        Authorization: 'Bearer ' + userToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar material', error);

    throw error;
  }
};

export const deleteMaterial = async (materialId, userToken) => {
  try {
    const response = await MaterialsApiService.delete('/materials/' + materialId, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao deletar material', error);

    throw error;
  }
};

export const duplicateMaterial = async (materialId, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/materials/${materialId}/duplicate`, {}, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao duplicar material', error);

    throw error;
  }
};

export const getMaterials = async (payload, userToken) => {
  try {
    let url = '/materials?';

    if (payload.search) {
      url += `search=${payload.search}&`;
    }

    if (payload.disciplineId) {
      url += `discipline_id=${payload.disciplineId}&`;
    }

    const response = await MaterialsApiService.get(url.slice(0, -1), {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao consultar materiais:', error);
    throw error;
  }
}

export const updateIndex = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/materials/${payload.materialId}/index`, payload, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar ordem do material', error);
    throw error;
  }
}

export const uploadItemsByZip = async (payload) => {
  try {
    const response = await MaterialsApiService.post('/materials/file/import', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    })

    return response.data
  } catch (error) {
    throw error.response.data
  }
}

export const createOrUpdateMaterialsReview = async (payload) => {
  try {
    const response = await MaterialsApiService.post('/material-feedbacks', payload)
    return response.data
  } catch {
    throw new Error("Ocorreu um erro ao realizar avaliação! Tente novamente")
  }
}

export const getMaterialsReview = async (payload) => {
  try {
    const response = await MaterialsApiService.get(`disciplines/${payload}/material-feedbacks`)
    return response.data
  } catch {
    throw new Error("Ocorreu um erro ao requisitar feedback de materiais")
  }
}

export const getMaterialAvaliationReasons = async () => {
  try {
    const response = await MaterialsApiService.get('/feedback/reasons')
    return response.data
  } catch {
    throw new Error("Ocorreu um erro ao requisitar motivos para avaliação!")
  }
}

export const getMaterialAvaliationReasonsInGroups = async () => {
  try {
    const response = await MaterialsApiService.get('/feedback/reasons/groups')
    return response.data
  } catch {
    throw new Error("Ocorreu um erro ao requisitar motivos para avaliação!")
  }
}

export const restrictMaterialToConsumers = async (requestPayload) => {
  try {
    const response = await MaterialsApiService.post(`/materials/${requestPayload?.materialId}/restrict-consumers`, requestPayload)
    return response.data
  } catch {
    throw new Error("Ocorreu um erro ao restringir material aos consumidores! Tente novamente")
  }
}

export const removeMaterialRestrictionToConsumers = async (requestPayload) => {
  try {
    const response = await MaterialsApiService.post(`/materials/${requestPayload?.materialId}/restrict-consumers/remove`, requestPayload)
    return response.data
  } catch {
    throw new Error("Ocorreu um erro ao remover restrição do material aos consumidores! Tente novamente")
  }
}

export default {
  restrictMaterialToConsumers,
  removeMaterialRestrictionToConsumers,
  getMaterialAvaliationReasonsInGroups,
  getMaterialAvaliationReasons,
  uploadItemsByZip,
  createMaterial,
  findMaterial,
  updateMaterial,
  deleteMaterial,
  duplicateMaterial,
  getMaterials,
  updateIndex,
  createOrUpdateMaterialsReview,
  getMaterialsReview
}